<script lang="ts">
  // components
  import { Alert } from "@getprovi/fizzy-svelte";

  // props
  export let level: string;
  export let singleInvoice: boolean;

  const warningText = singleInvoice
    ? "The selected date is past the due date."
    : "The selected date is past the due date for one or more of the invoices.";

  const errorText = singleInvoice
    ? "Payments for this distributor cannot be scheduled for after the invoice due date."
    : "The selected payment date occurs after the due date of one or more of the invoices. Payments for one of these distributors cannot be scheduled for after the invoice due date.";

  const determineAlertText = (level: string) => {
    if (level == "warning") {
      return warningText;
    } else if (level == "error") {
      return errorText;
    }
  };
  $: alertText = determineAlertText(level);
</script>

<div data-testid="due-date-alert" class="fizz-stack-16 fizz-text-left">
  <Alert text={alertText} {level} includeTitle={false} />
</div>
